<template>
    <main>
        <agile :navButtons=false>
            <img class="slide" src="http://www.shengjia-resin.com/temp/1.jpg" />
            <img class="slide" src="http://www.shengjia-resin.com/temp/2.jpg" />
            <img class="slide" src="http://www.shengjia-resin.com/temp/3.jpg" />
        </agile>
        <div class="article-wrapper">
            <article>
                <ul class="news-list">
                    <li class="news-list-item" v-for="(n, index) in datas" :key="index">
                        <img :src="n.imgurl" :alt="n.title">
                        <router-link :to="/news/+n.id">
                            <h4>{{n.title}}<span class="title-span">[...]</span></h4>
                            <p>{{n.timestamp}}</p>
                            <!--<div v-html="n.content"></div>-->
                        </router-link>
                    </li>
                </ul>
            </article>
        </div>
    </main>
</template>

<script>
    import qs from 'qs';
    import {
        VueAgile
    } from 'vue-agile'
    export default {
        name: 'News',
        components: {
            agile: VueAgile
        },
        data() {
            return {
                content: '',
                datas: [],
                newsCompanyType: '公司新闻',
                newsIndustryType: '行业新闻',
            }
        },
        mounted() {
            this.loadData();
        },
        methods: {
            loadData() {
                let params = {
                    newsCompanyType: this.newsCompanyType,
                    newsIndustryType: this.newsIndustryType
                }
                this.$axios.post('/findNewsMap', qs.stringify(params)).then(res => {
                    this.datas = res.data;
                }).catch(res => {
                    alert("数据获取失败")
                })
            },

        }
    }
</script>

<style lang="less" scoped>
    .news-list {
        margin: 0;
        padding: 0;

        &-item {
            list-style-type: none;
            padding: 16px 32px;

            >img {
                width: 150px;
                min-width: 150px;
                height: 100px;
                object-fit: cover;
            }

            p {
                margin: 0;
            }
        }
    }

    .title-span {
        color: #e4b248;
        font-family: "Muli", Helvetica, Arial, sans-serif;
        font-size: 13px;
        font-weight: 400;
        position: absolute;
        margin: auto 5px;
    }
</style>